import {triggerState,handleChange} from '../config'
const states = {
    regionId: '',
    systemType: '',
    deviceId: ''
};
const deviceList = {
    namespaced: true,
    state: handleChange({states,namespace:'gotparams'}),
    mutations: {
        set_area(state, payload) {
            triggerState({ state, property: "regionId", payload, namespace: "gotparams" })
        },
        set_systemType(state, payload) {
            triggerState({ state, property: "systemType", payload, namespace: "gotparams" })
            // state.systemType = value
        },
        set_deviceId(state, payload) {
            triggerState({state,property:"deviceId",payload,namespace: "gotparams" })
        }

    },
    gatter: {

    }
}


export default deviceList


// WEBPACK FOOTER //
// ./src/store/modules/gotparams.js